module.exports = __webpack_public_path__ + "img/should-u-apply.08400326.png";